import { validates } from '../utils/ValidateFormObject'

const diretriz = {
  tipo: {
    required: true
  },
  document: {
    conditionalRequired(obj) {
      const errorMessage = 'É obrigatório o upload de um arquivo HTML.'
      if (!obj['conteudoHtml']) {
        return {
          required: true,
          errorMessage
        }
      } else {
        return {
          required: false,
          errorMessage
        }
      }
    }
  },
  titulo: {
    required: true
  },
  subtitulo: {
    required: false
  },
  autoresDiretriz: {
    required: true
  },
  instituicao: {
    required: true
  },
  palavrasChave: {
    required: true
  },
  codigo: {
    required: true,
    func: validates.codigoArtigoDiretriz,
    errorMessage: 'Este campo deve conter um número de código de artigo válido.'
  },
  dataPublicacao: {
    required: true,
    func: validates.date,
    errorMessage: 'Este campo deve conter uma data válida.'
  }
}

export default diretriz



// WEBPACK FOOTER //
// ./src/contentSchema/diretriz.js